// Third party.
require('./partials/modernizr.js');

// window.tinyslider = require('../../node_modules/tiny-slider/dist/tiny-slider.js');
var $ = window.jQuery; // = require('jquery');
// require('@fortawesome/fontawesome-free/js/all.js');
// var CountUp = require('countup.js');
// import { tns } from '../../node_modules/tiny-slider/src/tiny-slider';

// Default functionality for navigation/search etc.
var navigation = require('./sections/navigation.js')($, Modernizr);
var search = require('./sections/search.js')($);

// Default functionality for each section required on the website.
// var banner = require('./sections/banner.js')($, tns);
import { heroBanner, imageSlider, customSlider } from './sections/banner.js';
import tabs from './sections/tabbed-content';
import { footer } from './sections/footer';
import { resources } from './sections/resources';
import faqs from './sections/faqs';

// var twocolumn = require('./sections/two-column.js')($, Modernizr);
// var countup = require('./sections/count-up.js')($, CountUp, Modernizr);
// var logocarousel = require('./sections/logo-carousel.js')($);
// var stickyelements = require('./sections/sticky-elements.js')($);
// var accordion = require('./sections/accordion.js')($);

$(document).ready(function() {

    /**
     * Custom functionality and overrides.
     */

    // init banners and sliders
    if( document.querySelector('.banner.init-tinyslider') !== null ) {
        heroBanner({
            container: '.banner.init-tinyslider'
        });
    }
    if( document.querySelector('.image-slider.init-tinyslider') !== null ) {
        imageSlider({
            container: '.image-slider.init-tinyslider'
        });
    }
    if( document.querySelector('.slider.slider-col-4.init-tinyslider') !== null) {

        customSlider({
            container: '.slider-col-4.init-tinyslider',
            controlsContainer: '.slider--controls',
            gutter: 20,
            items: 2,
            loop: false,
            nav: false,
            controls: false,
            mouseDrag: true,
            responsive: {
                768: {
                    items: 3,
                    controls: true
                },
                1024: {
                    items: 4,
                    gutter: 60
                }
            }
        })
    }
    if( document.querySelector('.slider.slider-col-1.slider-nav.init-tinyslider') !== null) {
        let slidersCol1 = document.querySelectorAll('.slider.slider-col-1.slider-nav.init-tinyslider');

        slidersCol1.forEach(slider => {
            let sliderContainer = slider.closest('.slider-container');
            let sliderNav = sliderContainer.querySelector('.slider--nav');
            customSlider({
                container: slider,
                navContainer: sliderNav,
                items: 1,
                loop: true,
                nav: true,
                controls: false,
                mouseDrag: true,
            })
        })
    }
    if( document.querySelector('.slider.slider-quotes.init-tinyslider') !== null) {
        let slidersQuote = document.querySelectorAll('.slider.slider-quotes.init-tinyslider');

        slidersQuote.forEach(slider => {
            let sliderNav = slider.querySelector('.slider-quote--nav');
            let sliderControls = slider.querySelector('.slider-quote--controls');
            customSlider({
                container: slider,
                navContainer: sliderNav,
                controlsContainer: sliderControls,
                items: 1,
                loop: true,
                nav: true,
                controls: false,
                mouseDrag: true,
                autoplay: false,
                center: true
            })
        })
    }

    //
    tabs.init();
    faqs.init();

    // resources
    resources($);



    $('.form.articles-data-form select').change(function() {
        newSearch();
    });

    $('.prev-page').click(function() {
        console.log('in');
        var current = parseInt($('input#current-page').val());

        $('input#current-page').val('' + (current - 1));
        continueSearch();
    });
    $('.next-page').click(function() {
        console.log('in');
        var current = parseInt($('input#current-page').val());

        $('input#current-page').val('' + (current + 1));
        continueSearch();
    });

    /**
     * Reset the results to page one and load results.
     */
    function newSearch() {
        $('input#current-page').val('1');
        $('form.articles-data-form').submit();
    }

    /**
     * Load results from the current search - page has most likely changed.
     */
    function continueSearch() {
        $('form.articles-data-form').submit();
    }

});

footer();
